import React from 'react'
import classNames from 'classnames'
import Image from '../Image'
import styles from './logos.module.sass'

export default function Logos({ logos, className, customStyles }) {
  return (
    <div className={classNames(styles.logosBlock)}>
      <ul className={classNames(className || styles.logosList, customStyles)}>
        {(logos || []).map((logo, i) => (
          <li key={i} className={styles.listItem}>
            <Image src={logo} />
          </li>
        ))}
      </ul>
    </div>
  )
}
